import { $applyNodeReplacement, type LexicalNode } from "lexical";
import type { UUID } from "../../../../../utils/uuid";
import { PollNode } from "./poll-node";
import { PollNodeMui } from "./poll-node-mui";
import type { PollNodeAnswerType } from "./types";

export function $createPollNode(
  headless: boolean,
  pollId: UUID,
  answerType: PollNodeAnswerType,
): PollNode {
  return $applyNodeReplacement(new (headless ? PollNode : PollNodeMui)(pollId, answerType));
}

export function $isPollNode(node: LexicalNode | null | undefined): node is PollNode {
  return node instanceof PollNode;
}
